<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">
          {{ $t('numberSquare.edit.subtitle') }}
        </span>
        <h3 class="page-title d-inline">
          {{ $t('numberSquare.edit.title') }}
        </h3>
        <router-link
          class="btn btn-success text-white float-right"
          :to="{ name: 'admin-puzzle-number-square-new' }"
        >
          {{ $t('numberSquare.edit.button.add') }}
        </router-link>
      </d-col>
    </d-row>
    <puzzle-number-square-page />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import PuzzleNumberSquarePage from '../components/PuzzleNumberSquarePage.vue';

export default {
  name: 'puzzle-number-square-edit',
  components: {
    PuzzleNumberSquarePage,
  },
  methods: {
    ...mapActions(['getPuzzleNumberSquare']),
  },
  mounted() {
    if (this.$route.params.puzzleId) {
      this.getPuzzleNumberSquare(this.$route.params.puzzleId);
    }
  },
};
</script>
